import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const Leaf: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2195 1.64611C10.7841 1.38221 11.3919 1.25 12 1.25C12.6081 1.25 13.2159 1.38221 13.7805 1.64611C15.9556 2.66278 17.6944 4.56688 18.8844 6.75814C20.076 8.95209 20.75 11.4916 20.75 13.8567C20.75 18.7557 16.845 22.75 12 22.75C7.15501 22.75 3.25 18.7557 3.25 13.8567C3.25 11.4916 3.92403 8.95209 5.11556 6.75814C6.30562 4.56688 8.04437 2.66278 10.2195 1.64611ZM11.25 2.85638C11.1157 2.89525 10.9835 2.94478 10.8546 3.005C9.04602 3.85036 7.51624 5.48075 6.4337 7.47402C5.35263 9.46459 4.75 11.7596 4.75 13.8567C4.75 17.6927 7.60821 20.8285 11.25 21.2108V2.85638ZM12.75 2.85638V7.18934L15.378 4.56137C14.6988 3.91209 13.9496 3.38092 13.1454 3.005C13.0165 2.94478 12.8843 2.89525 12.75 2.85638ZM16.3862 5.67443L12.75 9.31066V12.6893L17.7044 7.73496C17.6593 7.64743 17.6132 7.56044 17.5663 7.47402C17.2175 6.83177 16.8223 6.2272 16.3862 5.67443ZM18.3577 9.20294L12.75 14.8107V17.6893L18.9696 11.4697L19.0175 11.5176C18.8669 10.7404 18.6451 9.96116 18.3577 9.20294ZM19.2373 13.3234L12.75 19.8107V21.2108C16.3918 20.8285 19.25 17.6927 19.25 13.8567C19.25 13.6802 19.2457 13.5024 19.2373 13.3234Z"
        fill="#C1D8CF"
      />
    </svg>
  )
}

export default Leaf
